/** Stable identity for a backend-provided set of concrete grouped item IDs. */
export function groupedItemIdsKey(ids: readonly string[]): string {
  return JSON.stringify([...ids].sort());
}
